import { computed, reactive, ref } from "vue"
import { acceptHMRUpdate, defineStore } from "pinia"
import qrService from "@/services/qr.service"

export const qrStates = {
  deleted: 0,
  paused: 1,
  active: 2
}

export const stateReason = {
  bySystem: 1,
  byUser: 2
}

export const useQrsTableStore = defineStore("qrs-table", () => {
  const isFetchingData = ref(false)
  const data = ref([])
  const targetQr = ref(null)
  const isOpenMoveToProjectModal = ref(false)
  const isOpenShareQrModal = ref(false)
  const isOpenLinkSetupSidebar = ref(false)
  const totalItems = ref(0)
  const page = ref(1)
  const itemsPerPage = computed(() => 30)
  const showLimitReachedModal = ref(false)
  const filter = reactive({
    "project.uuid": null,
    title: null
  })

  function setIsFetchingData(newValue) {
    isFetchingData.value = newValue
  }

  async function getAll() {
    return await qrService.getAll({
      page: page.value,
      itemsPerPage: itemsPerPage.value,
      ...filter
    })
  }

  async function fetchData() {
    if (isFetchingData.value || totalItems.value?.length <= data.value?.length) return

    setIsFetchingData(true)
    const response = await getAll()
    data.value = page.value === 1 ? [...response.items] : [...data.value, ...response.items]
    totalItems.value = response.totalItems

    setIsFetchingData(false)
  }

  function setPage(newValue) {
    if (isFetchingData.value || totalItems.value === data.value?.length) return
    page.value = newValue
    return page.value
  }

  function setItemsPerPage(newValue) {
    itemsPerPage.value = newValue
  }

  async function setFilter(params) {
    await Object.assign(filter, { ...params })
    await setPage(1)
    data.value = []
    fetchData()
    totalItems.value = 0
    return filter
  }

  return {
    data,
    totalItems,
    page,
    filter,
    isFetchingData,
    targetQr,
    showLimitReachedModal,
    isOpenMoveToProjectModal,
    isOpenShareQrModal,
    isOpenLinkSetupSidebar,
    setFilter,
    setPage,
    fetchData,
    setItemsPerPage
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useQrsTableStore, import.meta.hot))
}
